import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  readonly hideProgressSubject = new BehaviorSubject<boolean>(false);
  hideProgress$ = this.hideProgressSubject.asObservable();

  setHideProgress(value: boolean) {
    this.hideProgressSubject.next(value);
  }
}
